<h2 class="text-xl font-semibold text-gray-800 mb-4">
  {{ 'CREDIT_DOCS.FO_LTR_TITLE' | translate }}
</h2>

<!-- TABS -->
<div class="flex flex-wrap gap-2 mb-4">
  <button
    (click)="setTab('all')"
    [ngClass]="activeTab === 'all' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'"
    class="px-4 py-2 rounded-lg"
  >
    {{ 'CREDIT_DOCS.ALL_DOCUMENTS' | translate }}
  </button>

  <button
    (click)="setTab('required')"
    [ngClass]="activeTab === 'required' ? 'bg-secondary text-white' : 'bg-gray-200 text-gray-700'"
    class="px-4 py-2 rounded-lg"
  >
    {{ 'CREDIT_DOCS.FINANCIAL_DOCUMENTS' | translate }}
  </button>
</div>

@if (crdtFoLtrSeq) {
  @if (activeTab === 'all') {
    <app-document
      [entitySeq]="crdtFoLtrSeq"
      [moduleSeq]="FACILITY_OFFER_LETTER_MODULE_SEQ"
      [issuanceDocsOnly]="false"
      [useFoLtrSaveApi]="true"
      [excludedDocSeqs]="uploadExcludedDocSeqs"
      [canUpload]="isAccountManager"
      [foLtrUploadGate]="true"
      foLtrUploadBlockedMessage="DOCUMENT.OTHER_DOCS_UPLOAD_BLOCKED"
      [foLtrAmActions]="true"
      [hideUploadedDocTypes]="isAccountManager"
      [showFoLtrDateFields]="true"
    >
    </app-document>
  }

  @if (activeTab === 'required') {
    <app-document
      [entitySeq]="crdtFoLtrSeq"
      [moduleSeq]="FACILITY_OFFER_LETTER_MODULE_SEQ"
      [issuanceDocsOnly]="true"
      [useFoLtrSaveApi]="true"
      [canUpload]="isAccountManager"
      [foLtrAmActions]="true"
      [showFoLtrDateFields]="true"
    >
    </app-document>
  }
}